import React from "react";
import BookingForm from "../components/BookingForm";
const ContactUs =()=>{
    return(
        <div className="contact-us-page">
            <h1>Contact Us</h1>
            <BookingForm />
        </div>
    )
}
export default ContactUs;